import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import Showdown from 'showdown';
import DOMPurify from 'dompurify';

const converter = new Showdown.Converter();

const getHtmlFromMarkdown = markdownText => {
  const rawHtml = converter.makeHtml(markdownText);
  const cleanHtml = DOMPurify.sanitize(rawHtml);
  return { __html: cleanHtml };
};

const Markdown = ({ markdown }) => {
  const content = useMemo(() => getHtmlFromMarkdown(markdown), [markdown]);

  return (
    // eslint-disable-next-line react/no-danger
    <div className="markdown-content" dangerouslySetInnerHTML={content} />
  );
};

Markdown.propTypes = { markdown: PropTypes.string };
Markdown.defaultProps = { markdown: undefined };

export default Markdown;
